import "core-js/modules/es.regexp.flags.js";
import * as React from "react";
function Languages(_a) {
  var host = _a.host;
  if (window.layoutSettings.content.display.flags === false) {
    return null;
  }
  if (host.languages === undefined) {
    return null;
  }
  var handledLanguages = ["DE", "EN", "FR", "IT", "ES", "FI", "NL", "PL", "PT", "RU", "TR", "CZ", "BU", "RO", "US"];
  var flags = [];
  for (var _i = 0, _b = host.languages; _i < _b.length; _i++) {
    var language = _b[_i];
    if (handledLanguages.includes(language.toUpperCase())) {
      flags.push(/*#__PURE__*/React.createElement("span", {
        key: language,
        className: "badge-language " + language.toLowerCase()
      }));
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "language-holder"
  }, flags);
}
export default Languages;